import React from 'react';

export default class SectionHeader extends React.Component {
  render() {
    const { titleText, titleDescription } = this.props;
    return (
      <div className="ui grid centered p-t-4 p-b-2">
        <div className="row centered center-aligned no-top no-bottom">
          <h1 className="primary-header-bold">{titleText}</h1>
        </div>
        <div className="row centered no-top no-bottom">
          <div className="nine wide computer sixteen wide mobile column center-aligned">
            <h4 className="secondary-header-regular">{titleDescription}</h4>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SectionHeader/index.jsx